export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/shipTableCalculator.596a2107.worker.js");
}
